export interface ByteValue {
  value: string | number | bigint;
  unit: string;
}

export function formatByteValue(
  bytes?: Partial<ByteValue> | null,
): string | undefined {
  if (bytes?.value == null || typeof bytes.unit !== "string") {
    return undefined;
  }

  const valueText = String(bytes.value).trim();
  const unit = bytes.unit.trim();
  if (!/^\d+$/.test(valueText) || !unit) {
    return undefined;
  }

  const scale = unit.includes("i")
    ? { factor: BigInt(1024), units: ["B", "KiB", "MiB", "GiB", "TiB", "PiB"] }
    : { factor: BigInt(1000), units: ["B", "KB", "MB", "GB", "TB", "PB"] };
  let unitIndex = scale.units.indexOf(unit);

  if (unitIndex < 0) return `${valueText}${unit}`;

  let value = BigInt(valueText);
  while (
    value >= scale.factor &&
    value % scale.factor === BigInt(0) &&
    unitIndex < scale.units.length - 1
  ) {
    value /= scale.factor;
    unitIndex += 1;
  }

  return `${value}${scale.units[unitIndex]}`;
}
